<template>
  <div class="start-page fade-in">
    <!-- Welcome Hero -->
    <div class="welcome-hero">
      <div class="welcome-content">
        <h1 class="welcome-title">
          <span class="greeting">Bem-vindo,</span>
          <span class="user-name">{{ userData.name || 'Utilizador' }}</span>
        </h1>
        <p class="welcome-subtitle">Aqui encontra uma visão geral das suas aplicações</p>
      </div>
      <div class="welcome-actions is-hidden-mobile">
        <router-link to="/companies/create" class="button is-primary" v-if="isReseller">
          <i class="fas fa-plus mr-2"></i>
          Criar Goldylocks
        </router-link>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="stats-grid mt-6" v-if="companies.length > 0">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-building"></i>
        </div>
        <div class="stat-content">
          <p class="stat-value">{{ companies.length }}</p>
          <p class="stat-label">Total Aplicações</p>
        </div>
      </div>
      
      <div class="stat-card stat-active">
        <div class="stat-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        <div class="stat-content">
          <p class="stat-value">{{ activeCount }}</p>
          <p class="stat-label">Ativas</p>
        </div>
      </div>
      
      <div class="stat-card stat-warning" v-if="expiringCount > 0">
        <div class="stat-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <div class="stat-content">
          <p class="stat-value">{{ expiringCount }}</p>
          <p class="stat-label">A expirar</p>
        </div>
      </div>
    </div>

    <!-- Notifications Section -->
    <div class="section notifications-section mt-6">
      <div class="section-header">
        <h2 class="section-title">Notificações Recentes</h2>
      </div>
      
      <UserNotificationsTable></UserNotificationsTable>
    </div>
  </div>
</template>

<script>
import UserNotificationsTable from "@/components/dashboard/UserNotificationsTable";

export default {
  name: "Start",
  components: {UserNotificationsTable},
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    companies() {
      return this.$store.getters.companies;
    },
    isReseller() {
      return this.userData.type === "2" || this.userData.type === "1"
    },
    activeCount() {
      return this.companies.filter(c => c.active).length;
    },
    expiringCount() {
      return this.companies.filter(c => {
        const days = c.modules && c.modules.vendas ? c.modules.vendas.remainingDays : 0;
        return days > 0 && days <= 30;
      }).length;
    }
  }
}
</script>

<style scoped>
.start-page {
  max-width: 1200px;
}

.welcome-hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 32px;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  border-radius: var(--radius-xl);
  color: white;
}

.welcome-title {
  margin: 0;
}

.greeting {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  opacity: 0.9;
  margin-bottom: 4px;
}

.user-name {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
}

.welcome-subtitle {
  margin-top: 8px;
  opacity: 0.85;
  font-size: 0.9rem;
}

.welcome-actions .button {
  background: white;
  color: var(--primary);
  font-weight: 600;
}

.welcome-actions .button:hover {
  background: var(--surface-elevated);
  color: var(--primary);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.stat-card {
  background: var(--surface);
  border-radius: var(--radius-lg);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: var(--shadow-sm);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all var(--transition-base);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-md);
  background: var(--primary-50);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  font-size: 1.25rem;
}

.stat-active .stat-icon {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
}

.stat-warning .stat-icon {
  background: rgba(245, 158, 11, 0.1);
  color: var(--warning);
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 0.8rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
}

@media only screen and (max-width: 768px) {
  .welcome-hero {
    padding: 20px;
  }
  
  .user-name {
    font-size: 1.5rem;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
